<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex align-items-center justify-content-between">
          <h4 class="mb-0 font-size-18">Create {{module}}</h4>
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item">
                <router-link :to="{name:'dashboards'}">Dashboards</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link :to="{name:table_module}">{{ module }}</router-link>
              </li>
              <li class="breadcrumb-item active">Create</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 grid-margin">
        <componentForm
          :module="module"
          :table_module="table_module"
          :alias_table="alias_table"
          :fields="fields"
        ></componentForm>
      </div>
    </div>
  </div>
</template>

<script>
import componentForm from "@/components/form";
export default {
  data() {
    return {
      module: "Days Off",
      table_module: "day_off",
      alias_table: "day_off",
      fields: {},
    };
  },
  components: {
    componentForm,
  },
  mounted() {
    this.axios.get("/" + this.table_module + "/create").then((response) => {
      this.fields = response.data.data;
    });
  },
};
</script>